import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { saveSubscription } from 'ducks/billing'
import { fetchOrganizations, getOrganizations } from 'ducks/organizations'

import Modal from 'components/Shared/Modal'
import SignupForm from 'components/Shared/TrialWarning/SignupForm'
import { SubmissionError } from 'redux-form'

import AuthPage from '../AuthPage'
import { withStripePromise } from '../../Shared/TrialWarning/LoadStripe'

class Payment extends Component {
  componentDidMount() {
    const { fetchOrganizations } = this.props
    fetchOrganizations()
  }

  handleSubmit = async values => {
    const { stripe, saveSubscription, organizationId } = this.props
    const { plan: planType, coupon, name } = values

    const { token, error } = await stripe.createToken({ name })

    if (token && organizationId) {
      try {
        await saveSubscription(organizationId, {
          coupon,
          planType,
          stripeToken: token?.id,
        })

        if (planType === 'pro' || planType === 'individual') {
          if (window.ga) {
            window.ga('send', {
              hitType: 'event',
              eventCategory: 'button',
              eventAction: 'click',
              eventLabel: 'Payment Made',
              eventValue: 50,
            })
          }
        }

        if (planType === 'business' || planType === 'launch') {
          if (window.ga) {
            window.ga('send', {
              hitType: 'event',
              eventCategory: 'button',
              eventAction: 'click',
              eventLabel: 'Payment Made',
              eventValue: 200,
            })
          }
        }

        this.handleSuccess()
      } catch (err) {
        const { response } = err

        const errorMessage =
          response?.data?.error || 'An unknown error occurred'

        throw new SubmissionError({ _error: errorMessage })
      }
    } else {
      console.log('ERROR:', error)

      throw new SubmissionError({
        _error: error.message,
      })
    }
  }

  handleSuccess = () => {
    const { history } = this.props

    return history.push('/first-app-setup')
  }

  render() {
    return (
      <AuthPage>
        <Modal
          className="modal-wrapper-text-aligned-left"
          size="lg"
          scrolling
          hideDimmer
        >
          <SignupForm
            hideFreeTier
            hideStorage
            title="Choose your plan to get started"
            submitText="Start!"
            onSubmit={this.handleSubmit}
            initialValues={{ plan: 'pro' }}
          />
        </Modal>
      </AuthPage>
    )
  }
}

const mapStateToProps = state => {
  const organizationId = getOrganizations(state)?.[0]?.id

  return {
    organizationId,
  }
}

const WrappedPayment = connect(mapStateToProps, {
  fetchOrganizations,
  saveSubscription,
})(withRouter(withStripePromise(Payment)))

const PaymentWrapper = () => {
  return <WrappedPayment />
}

export default PaymentWrapper
